import React, {useState} from 'react'
import type {
  IProductSwitcherCategory,
  IProductSwitcherSubItem,
} from '../../../../types/userTypes'
import {ReactComponent as UnLock} from '../../../../assets/Icons/Unlock.svg'
import styles from '../ProductSwitcher.module.scss'
import {useWt} from '@npm-questionpro/wick-ui-lib'
import {GLOBAL} from '../../../../Translation/English/global'

interface IProductSwitcherMenuHoveredItemProps {
  parentItem: IProductSwitcherCategory
  item: IProductSwitcherSubItem
}

export const ProductSwitcherMenuHoveredItem = ({
  parentItem: _parentItem,
  item,
}: IProductSwitcherMenuHoveredItemProps): React.JSX.Element => {
  const [, setHovered] = useState<boolean>(false)
  const wt = useWt()
  return (
    <li
      className={styles.hoverItemLi}
      onMouseOver={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {item?.active ? (
        <a className={styles.hoverItemLink} href={item?.link}>
          <div className={styles.hoverItemIcon}>
            <img
              width={16}
              height={16}
              src={item?.logo}
              color={'#f10000'}
              alt={item?.name}
            />
          </div>
          <span className={styles.hoverItemName}>{item?.name}</span>
        </a>
      ) : (
        <div className={styles.hoverItemLock}>
          <UnLock />
          <p>{wt(GLOBAL.upgradeToUnlock)}</p>
        </div>
      )}
    </li>
  )
}
